module.exports = __webpack_public_path__ + "media/application/images/icons/simple-arrow-down-6567223c5c4a09a70e10329e644cb780.svg";